module.exports = __webpack_public_path__ + "static-v-shop/1786469036613/img/logo_master.c8bdcd8d.svg";